<div id="all">
  <header class="header">
    <div class="arrow-button" onclick="history.back()"></div>
    <h1>
      <p>初回ログイン</p>
    </h1>
  </header>

  <div class="container" *ngIf="userinfo">
    <div class="container-item">
      <p class="base-text">以下のStation IDで使用開始しても良いですか？</p>
      <div>
        <p class="base-title-text">お名前</p>
        <p class="base-text">
          {{ userinfo.family_name }} {{ userinfo.given_name }}
        </p>
      </div>

      <div>
        <p class="base-title-text">メールアドレス</p>
        <p class="base-text">{{ userinfo.email }}</p>
      </div>

      <div class="checkbox-group">
        <div class="checkbox">
          <input type="checkbox" [(ngModel)]="isAgreed" />
        </div>
        <label>
          <span
            ><a
              [href]="termsUrl"
              target="_blank"
              class="text-link primary--text"
              >利用規約</a
            >および<a
              [href]="privacyPolicyUrl"
              target="_blank"
              class="text-link primary--text"
              >プライバシーポリシー</a
            >に同意します。</span
          ></label
        >
      </div>
      <div class="center">
        <p *ngIf="isShowErrorMessage" class="text-error">
          利用規約およびプライバシーポリシーに同意してください
        </p>
      </div>

      <div class="center">
        <button (click)="clickLoginButton()" class="primary mt-16">
          この Statin ID で使用開始する
        </button>
      </div>
    </div>
  </div>
</div>
